<template>
    <div class="LifeskillNumbershapeWithProgress">
        <AnimatedNumbershape :number="lifeskillId" :play="play" color="white" reversed />
        <CircularProgress
            v-if="totalLifekeys"
            class="lifekeyProgress"
            :progress="lifekeyProgress"
            track-color="#ffffff08"
            :color="theme.color"
            :stroke-width="3"
        />
    </div>
</template>

<script>
import CircularProgress from '@/components/CircularProgress';
import AnimatedNumbershape from '@/components/AnimatedNumbershape';

export default {
    components: { CircularProgress, AnimatedNumbershape },
    props: {
        lifeskillId: {
            type: String,
            required: true
        },
        play: {
            type: Boolean,
            default: false
        }
    },
    inject: ['theme'],
    computed: {
        stats() {
            return this.$store.getters['moduleApp/getLifeskillStats'](this.lifeskillId);
        },
        aquiredLifekeys() {
            return (
                this.stats.acquiredTheoryLifekeys +
                this.stats.acquiredPracticeLifekeys +
                this.stats.acquiredVideoLifekeys
            );
        },
        totalLifekeys() {
            return this.stats.totalTheoryLifekeys + this.stats.totalPracticeLifekeys + this.stats.totalVideoLifekeys;
        },
        lifekeyProgress() {
            if (this.totalLifekeys) {
                return this.aquiredLifekeys / this.totalLifekeys;
            } else {
                return 0;
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.LifeskillNumbershapeWithProgress {
    position: relative;
    background-color: rgba(black, 0.3);
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
}

.AnimatedNumbershape {
    $size: 80%;
    width: $size;
    height: $size;
}

.lifekeyProgress {
    $offset: 0em;
    position: absolute;
    top: -$offset;
    right: -$offset;
    bottom: -$offset;
    left: -$offset;
}
</style>
